var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdtBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35819_160666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10.5C20 16.0417 15.5417 20.5 10 20.5C4.4583 20.5 0 16.0417 0 10.5C0 4.9583 4.4583 0.5 10 0.5C15.5417 0.5 20 4.9583 20 10.5ZM14.6806 8.27257V6.5H5.31938V8.27257H8.83334V9.50155C6.36538 9.63288 4.51382 10.1723 4.5001 10.8188L4.5 12.1667C4.51374 12.8132 6.36538 13.3526 8.83334 13.4839V16.5H11.1667V13.4839C13.6346 13.3526 15.4862 12.8132 15.4999 12.1667L15.5 10.8188C15.4863 10.1723 13.6346 9.63288 11.1667 9.50155V8.27257H14.6806ZM15.3767 11.4925C14.8379 12.1016 12.6366 12.5578 10.0028 12.5578C7.36902 12.5578 5.16765 12.1016 4.62891 11.4925C5.08576 10.976 6.73823 10.5695 8.83613 10.4579V11.7446C9.21214 11.7646 9.60247 11.7751 10.0028 11.7751C10.4031 11.7751 10.7934 11.7646 11.1695 11.7446V10.4579C13.2673 10.5695 14.9198 10.976 15.3767 11.4925Z",
    fill: "#7FFAE2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35819_160666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtBlue);
export default __webpack_public_path__ + "static/media/usdt-blue.fc76a46cfcf4c6dff78cfbe0b0c707d5.svg";
export { ForwardRef as ReactComponent };